let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bKZv1")).then(() => parcelRequire('9letx'));